<template>
  <v-card>
    <v-toolbar style="background-color: #890000; color: #fff">
      <v-toolbar-title>
        <span class="headline">Deletar óbito</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <div class="container pt-8">
        <div class="row justify-content-center">
          <div class="col-10">
            <div class="text-center">
              <h3>Deseja realmente excluir o seguinte óbito?</h3>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-8">
            <v-card>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody class="text-left">
                    <tr>
                      <td>Pet</td>
                      <td>{{ infoObito.nome_pet }}</td>
                    </tr>
                    <tr>
                      <td>Tutor</td>
                      <td>{{ infoObito.nome_tutor }}</td>
                    </tr>
                    <!-- <tr>
                      <td>Unidade</td>
                      <td>infoObito.descricao</td>
                    </tr> -->
                    <tr>
                      <td>Executor</td>
                      <td>{{ infoObito.nome_executor }}</td>
                    </tr>
                    <tr>
                      <td>Tipo</td>
                      <td>{{ infoObito.Tipo_de_Óbito }}</td>
                    </tr>
                    <tr>
                      <td>data/hora</td>
                      <td>
                        {{
                          transformData(
                            infoObito.data_do_obito,
                            infoObito.hora_do_obito
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-actions class="d-flex justify-content-between">
      <v-btn color="primary" outlined @click="$emit('close')"> Cancelar </v-btn>
      <v-btn color="#890000" dark @click="deleteObito()">
        Deletar óbito
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Mixin from "@/mixins/vuex_snackbar_mixin.js";
import ObitoService from "@/services/obito_service.js";

export default {
  mixins: [Mixin],
  props: {
    infoObito: {},
  },
  data() {
    return {
      services: {
        obitoService: ObitoService.build(),
      },
      unidadeId: 0,
      procedimentoList: [{ desc: "Teste", value: 1 }],
      procedimentoSelected: "",
      data_obito: "",
      hora_obito: "",
      obs_obito: "",
    };
  },
  watch: {},
  async beforeMount() {
    this.unidadeId = await JSON.parse(sessionStorage.getItem("vuex")).unidade
      .id;
  },
  mounted() {},
  methods: {
    deleteObito() {
      this.services.obitoService
        .deletarObito(this.infoObito.id_requisicao, this.infoObito.pet_id)
        .then(async (response) => {
          if (response.status !== 200) return;
          const { data } = await response.json();
          console.log("data", data);
          //localStorage.removeItem("obito");
          this.$emit("concluido");
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          // this.loading = false;
        });
    },
    transformData(data_obito, hora_obito = null) {
      let dataArr = data_obito
        .split("-")
        .reverse()
        .join("/");
      if (hora_obito) {
        let horaArr = hora_obito.split(":");
        return `${dataArr} ${horaArr[0]}:${horaArr[1]}`;
      }
      return `${dataArr}`;
    },
  },
};
</script>
<style></style>
